import React, { useEffect, useState } from 'react';
import axios from "axios";
import { useParams } from 'react-router-dom';
import Layout from "./Components/Layout";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const AddRaws = () => {
    const [category, setCategory] = useState('');
    const [id, setId] = useState('');
    const [rawMaterialName, setRawMaterialName] = useState('');
    const [activeInactive, setActiveInactive] = useState('');
    const [identityTestingCost, setIdentityTestingCost] = useState('');
    const [testingMethod, setTestingMethod] = useState('');
    const [typeMicroLimit, setTypeMicroLimit] = useState('');
    const [commonName, setCommonName] = useState('');
    const [botanicalName, setBotanicalName] = useState('');
    const [hoc, setHOC] = useState('');
    const [part, setPart] = useState('');
    const [form, setForm] = useState('');
    const [ratio, setRatio] = useState('');
    const [lodNmt, setLOD_NMT] = useState('');
    const [loiNmt, setLOI_NMT] = useState('');
    const [ingredientDeclarationOnLabel, setIngredientDeclarationOnLabel] = useState('');
    const [identity, setIdentity] = useState('');
    const [limit0, setLimit0] = useState('');
    const [limit0Method, setLimit0Method] = useState('');
    const [limit0Reference, setLimit0Reference] = useState('');
    const [limit0TestingCost, setLimit0TestingCost] = useState('');
    const [active1, setActive1] = useState('');
    const [limit1, setLimit1] = useState('');
    const [limit1Method, setLimit1Method] = useState('');
    const [limit1Reference, setLimit1Reference] = useState('');
    const [limit1TestingCost, setLimit1TestingCost] = useState('');
    const [active2, setActive2] = useState('');
    const [limit2, setLimit2] = useState('');
    const [limit2Method, setLimit2Method] = useState('');
    const [limit2Reference, setLimit2Reference] = useState('');
    const [limit2TestingCost, setLimit2TestingCost] = useState('');
    const [appearance, setAppearance] = useState('');
    const [color, setColor] = useState('');
    const [odor, setOdor] = useState('');
    const [taste, setTaste] = useState('');
    const [bulk, setBulk] = useState('');
    const [tapped, setTapped] = useState('');
    const [meshSize, setMeshSize] = useState('');
    const [arsenic, setArsenic] = useState('');
    const [cadmium, setCadmium] = useState('');
    const [leadx, setLeadx] = useState('');
    const [mercury, setMercury] = useState('');
    const [tamc, setTAMC] = useState('');
    const [tymc, setTYMC] = useState('');
    const [coliforms, setColiforms] = useState('');
    const [eColi, setEColi] = useState('');
    const [salmonellaSpp, setSalmonellaSpp] = useState('');
    const [staphAureus, setStaphAureus] = useState('');
    const [absent, setAbsent] = useState('');
    const [milk, setMilk] = useState('');
    const [egg, setEgg] = useState('');
    const [soy, setSoy] = useState('');
    const [fish, setFish] = useState('');
    const [shellfish, setShellfish] = useState('');
    const [treeNuts, setTreeNuts] = useState('');
    const [peanuts, setPeanuts] = useState('');
    const [wheat, setWheat] = useState('');
    const [gluten, setGluten] = useState('');
    const [overage, setOverage] = useState('');
    const [cost, setCost] = useState('');
    const [costUnit, setCostUnit] = useState('');
    const [costG, setCostG] = useState('');
    const [moqKg, setMOQKg] = useState('');
    const [amazonTesting, setAmazonTesting] = useState('');
    const [laboratory, setLaboratory] = useState('');
    const [solubilityGML, setSolubilityGML] = useState('');
    
    // Extract min and max values from category selection
    const getCategoryValues = (categoryStr) => {
        if (!categoryStr) return null;
        const match = categoryStr.match(/(\d+)\s*[–-]\s*(\d+)/);
        if (match) {
            return {
                min: parseInt(match[1]),
                max: parseInt(match[2])
            };
        }
        return null;
    };

    // Fetch max ID when category changes
    useEffect(() => {
        if (category) {
            const categoryValues = getCategoryValues(category);
            if (categoryValues) {
                axios.get(`raws/get-max-id-in-range/${categoryValues.min}/${categoryValues.max}`)
                    .then((response) => {
                        const maxId = response.data.max_id;
                        if (maxId !== null) {
                            const nextId = parseInt(maxId) + 1;
                            // Check if next ID is within category
                            if (nextId > categoryValues.max) {
                                toast.error('Outside of Category');
                                setId('');
                            } else {
                                setId(nextId.toString().padStart(5, '0'));
                            }
                        } else {
                            // No existing ID in category, start with minimum
                            setId(categoryValues.min.toString().padStart(5, '0'));
                        }
                    })
                    .catch((error) => {
                        console.error('Error fetching max ID:', error);
                        toast.error('Error fetching ID');
                    });
            }
        }
    }, [category]);

    const onSaveClick = () => {
        // Validate ID is within category before saving
        if (category && id) {
            const categoryValues = getCategoryValues(category);
            if (categoryValues) {
                const numId = parseInt(id);
                if (numId < categoryValues.min || numId > categoryValues.max) {
                    toast.error('ID is outside of selected category');
                    return;
                }
            }
        }
        
        let dataObj = {
            category,
            id,
            rawMaterialName,
            activeInactive,
            identityTestingCost,
            testingMethod,
            typeMicroLimit,
            commonName,
            botanicalName,
            hoc,
            part,
            form,
            ratio,
            lodNmt,
            loiNmt,
            ingredientDeclarationOnLabel,
            identity,
            limit0,
            limit0Method,
            limit0Reference,
            limit0TestingCost,
            active1,
            limit1,
            limit1Method,
            limit1Reference,
            limit1TestingCost,
            active2,
            limit2,
            limit2Method,
            limit2Reference,
            limit2TestingCost,
            appearance,
            color,
            odor,
            taste,
            bulk,
            tapped,
            meshSize,
            arsenic,
            cadmium,
            leadx,
            mercury,
            tamc,
            tymc,
            coliforms,
            eColi,
            salmonellaSpp,
            staphAureus,
            absent,
            milk,
            egg,
            soy,
            fish,
            shellfish,
            treeNuts,
            peanuts,
            wheat,
            gluten,
            overage,
            cost,
            costUnit,
            costG,
            moqKg,
            amazonTesting,
            laboratory,
            solubilityGML
        };
        axios.put(`raws/add-raws-data`, dataObj)
            .then((data) => {
                console.log(data.data.id)
                if(data.data.id)
                {
                    toast.success('Record added successfully');
                    // Redirect to raws list after a short delay to show the toast
                    setTimeout(() => {
                        window.location.href = "/raws";
                    }, 1500);
                }
                
            })
            .catch((error) => {
                console.error('Error adding record:', error);
                toast.error('Error adding record');
            });
    };
    
    const openPage = (dataId) => {
        window.location.href = "/view-parts/"+dataId;
    };

    return (
        <Layout>
            <div style={{ height: 'calc(100vh - 70px)', overflow: 'auto', padding: '20px' }}>
                <div className="container-fluid" style={{ paddingLeft: '0px', paddingRight: '0px' }}>
                    
                    {/* Breadcrumb */}
                    <div style={{ marginBottom: '20px' }}>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb" style={{ background: 'transparent', padding: '0', margin: '0' }}>
                                <li className="breadcrumb-item">
                                    <a href="/parts" style={{ color: '#6b7280', textDecoration: 'none' }}>
                                        <i className="ti-arrow-left" style={{ marginRight: '5px' }}></i>
                                        Parts
                                    </a>
                                </li>
                                <li className="breadcrumb-item active" aria-current="page" style={{ color: '#333', fontWeight: '500' }}>
                                    Add New Part
                                </li>
                            </ol>
                        </nav>
                    </div>

                    <form onSubmit={(e) => {e.preventDefault(); onSaveClick();}}>
                        {/* All Fields Section */}
                        <div style={{ background: 'white', borderRadius: '12px', border: '1px solid #e5e7eb', padding: '24px', marginBottom: '24px' }}>
                            <h4 style={{ fontWeight: '600', marginBottom: '20px', color: '#333' }}>Part Details</h4>
                            
                            <div className="row">
                                <div className="col-lg-6 mb-3">
                                    <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>
                                        Category <span style={{color: 'red'}}>*</span>
                                    </label>
                                    <select 
                                        className="form-control" 
                                        value={category} 
                                        onChange={(e) => setCategory(e.target.value)} 
                                        required
                                        style={{ height: '45px' }}
                                    >
                                        <option value="">Select Category</option>
                                        <option value="Template: 00000 – 09999">Template: 00000 – 09999</option>
                                        <option value="Container: 10000 - 19999">Container: 10000 - 19999</option>
                                        <option value="Closure: 20000 - 29999">Closure: 20000 - 29999</option>
                                        <option value="Open: 30000 – 39999">Open: 30000 – 39999</option>
                                        <option value="Open: 40000 – 49999">Open: 40000 – 49999</option>
                                        <option value="Open: 50000 – 59999">Open: 50000 – 59999</option>
                                        <option value="Raw Material: 60000 – 69999">Raw Material: 60000 – 69999</option>
                                        <option value="Secondary Packaging: 70000 – 79999">Secondary Packaging: 70000 – 79999</option>
                                        <option value="Ancillary Packaging: 80000 – 89999">Ancillary Packaging: 80000 – 89999</option>
                                        <option value="Consumable: 90000 – 99999">Consumable: 90000 – 99999</option>
                                    </select>
                                </div>
                                <div className="col-lg-6 mb-3">
                                    <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>APEXID#</label>
                                    <input 
                                        type="number" 
                                        step="0.01" 
                                        className="form-control" 
                                        value={id} 
                                        onChange={(e) => setId(e.target.value)}
                                        style={{ height: '45px' }}
                                    />
                                </div>
                                <div className="col-lg-6 mb-3">
                                    <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Raw Material Name</label>
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        value={rawMaterialName} 
                                        onChange={(e) => setRawMaterialName(e.target.value)}
                                        style={{ height: '45px' }}
                                    />
                                </div>
                                <div className="col-lg-6 mb-3">
                                    <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Active/Inactive</label>
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        value={activeInactive} 
                                        onChange={(e) => setActiveInactive(e.target.value)}
                                        style={{ height: '45px' }}
                                    />
                                </div>
                                <div className="col-lg-6 mb-3">
                                    <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Identity Testing Cost</label>
                                    <input 
                                        type="number" 
                                        step="0.01" 
                                        className="form-control" 
                                        value={identityTestingCost} 
                                        onChange={(e) => setIdentityTestingCost(e.target.value)}
                                        style={{ height: '45px' }}
                                    />
                                </div>
                                <div className="col-lg-6 mb-3">
                                    <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Testing Method</label>
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        value={testingMethod} 
                                        onChange={(e) => setTestingMethod(e.target.value)}
                                        style={{ height: '45px' }}
                                    />
                                </div>
                                <div className="col-lg-6 mb-3">
                                    <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Type (Micro Limit)</label>
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        value={typeMicroLimit} 
                                        onChange={(e) => setTypeMicroLimit(e.target.value)}
                                        style={{ height: '45px' }}
                                    />
                                </div>
                                <div className="col-lg-6 mb-3">
                                    <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Common Name</label>
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        value={commonName} 
                                        onChange={(e) => setCommonName(e.target.value)}
                                        style={{ height: '45px' }}
                                    />
                                </div>
                                <div className="col-lg-6 mb-3">
                                    <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Botanical Name</label>
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        value={botanicalName} 
                                        onChange={(e) => setBotanicalName(e.target.value)}
                                        style={{ height: '45px' }}
                                    />
                                </div>
                                <div className="col-lg-6 mb-3">
                                    <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>HOC</label>
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        value={hoc} 
                                        onChange={(e) => setHOC(e.target.value)}
                                        style={{ height: '45px' }}
                                    />
                                </div>
                                <div className="col-lg-6 mb-3">
                                    <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Part</label>
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        value={part} 
                                        onChange={(e) => setPart(e.target.value)}
                                        style={{ height: '45px' }}
                                    />
                                </div>
                                <div className="col-lg-6 mb-3">
                                    <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Form</label>
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        value={form} 
                                        onChange={(e) => setForm(e.target.value)}
                                        style={{ height: '45px' }}
                                    />
                                </div>
                                <div className="col-lg-6 mb-3">
                                    <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Ratio</label>
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        value={ratio} 
                                        onChange={(e) => setRatio(e.target.value)}
                                        style={{ height: '45px' }}
                                    />
                                </div>
                                <div className="col-lg-6 mb-3">
                                    <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>LOD (NMT)</label>
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        value={lodNmt} 
                                        onChange={(e) => setLOD_NMT(e.target.value)}
                                        style={{ height: '45px' }}
                                    />
                                </div>
                                <div className="col-lg-6 mb-3">
                                    <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>LOI (NMT)</label>
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        value={loiNmt} 
                                        onChange={(e) => setLOI_NMT(e.target.value)}
                                        style={{ height: '45px' }}
                                    />
                                </div>
                                <div className="col-lg-12 mb-3">
                                    <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Ingredient Declaration on Label</label>
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        value={ingredientDeclarationOnLabel} 
                                        onChange={(e) => setIngredientDeclarationOnLabel(e.target.value)}
                                        style={{ height: '45px' }}
                                    />
                                </div>
                                <div className="col-lg-6 mb-3">
                                    <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Identity</label>
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        value={identity} 
                                        onChange={(e) => setIdentity(e.target.value)}
                                        style={{ height: '45px' }}
                                    />
                                </div>
                                <div className="col-lg-6 mb-3">
                                    <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Limit</label>
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        value={limit0} 
                                        onChange={(e) => setLimit0(e.target.value)}
                                        style={{ height: '45px' }}
                                    />
                                </div>
                                <div className="col-lg-6 mb-3">
                                    <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Method</label>
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        value={limit0Method} 
                                        onChange={(e) => setLimit0Method(e.target.value)}
                                        style={{ height: '45px' }}
                                    />
                                </div>
                                <div className="col-lg-6 mb-3">
                                    <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Reference</label>
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        value={limit0Reference} 
                                        onChange={(e) => setLimit0Reference(e.target.value)}
                                        style={{ height: '45px' }}
                                    />
                                </div>
                                <div className="col-lg-6 mb-3">
                                    <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Testing Cost</label>
                                    <input 
                                        type="number" 
                                        step="0.01" 
                                        className="form-control" 
                                        value={limit0TestingCost} 
                                        onChange={(e) => setLimit0TestingCost(e.target.value)}
                                        style={{ height: '45px' }}
                                    />
                                </div>
                                <div className="col-lg-6 mb-3">
                                    <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Active 1</label>
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        value={active1} 
                                        onChange={(e) => setActive1(e.target.value)}
                                        style={{ height: '45px' }}
                                    />
                                </div>
                                <div className="col-lg-6 mb-3">
                                    <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Limit 1</label>
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        value={limit1} 
                                        onChange={(e) => setLimit1(e.target.value)}
                                        style={{ height: '45px' }}
                                    />
                                </div>
                                <div className="col-lg-6 mb-3">
                                    <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Method</label>
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        value={limit1Method} 
                                        onChange={(e) => setLimit1Method(e.target.value)}
                                        style={{ height: '45px' }}
                                    />
                                </div>
                                <div className="col-lg-6 mb-3">
                                    <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Reference</label>
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        value={limit1Reference} 
                                        onChange={(e) => setLimit1Reference(e.target.value)}
                                        style={{ height: '45px' }}
                                    />
                                </div>
                                <div className="col-lg-6 mb-3">
                                    <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Testing Cost</label>
                                    <input 
                                        type="number" 
                                        step="0.01" 
                                        className="form-control" 
                                        value={limit1TestingCost} 
                                        onChange={(e) => setLimit1TestingCost(e.target.value)}
                                        style={{ height: '45px' }}
                                    />
                                </div>
                                <div className="col-lg-6 mb-3">
                                    <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Active 2</label>
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        value={active2} 
                                        onChange={(e) => setActive2(e.target.value)}
                                        style={{ height: '45px' }}
                                    />
                                </div>
                                <div className="col-lg-6 mb-3">
                                    <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Limit 2</label>
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        value={limit2} 
                                        onChange={(e) => setLimit2(e.target.value)}
                                        style={{ height: '45px' }}
                                    />
                                </div>
                                <div className="col-lg-6 mb-3">
                                    <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Method</label>
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        value={limit2Method} 
                                        onChange={(e) => setLimit2Method(e.target.value)}
                                        style={{ height: '45px' }}
                                    />
                                </div>
                                <div className="col-lg-6 mb-3">
                                    <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Reference</label>
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        value={limit2Reference} 
                                        onChange={(e) => setLimit2Reference(e.target.value)}
                                        style={{ height: '45px' }}
                                    />
                                </div>
                                <div className="col-lg-6 mb-3">
                                    <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Testing Cost</label>
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        value={limit2TestingCost} 
                                        onChange={(e) => setLimit2TestingCost(e.target.value)}
                                        style={{ height: '45px' }}
                                    />
                                </div>
                                <div className="col-lg-6 mb-3">
                                    <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Appearance</label>
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        value={appearance} 
                                        onChange={(e) => setAppearance(e.target.value)}
                                        style={{ height: '45px' }}
                                    />
                                </div>
                                <div className="col-lg-6 mb-3">
                                    <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Color</label>
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        value={color} 
                                        onChange={(e) => setColor(e.target.value)}
                                        style={{ height: '45px' }}
                                    />
                                </div>
                                <div className="col-lg-6 mb-3">
                                    <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Odor</label>
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        value={odor} 
                                        onChange={(e) => setOdor(e.target.value)}
                                        style={{ height: '45px' }}
                                    />
                                </div>
                                <div className="col-lg-6 mb-3">
                                    <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Taste</label>
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        value={taste} 
                                        onChange={(e) => setTaste(e.target.value)}
                                        style={{ height: '45px' }}
                                    />
                                </div>
                                <div className="col-lg-6 mb-3">
                                    <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Bulk</label>
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        value={bulk} 
                                        onChange={(e) => setBulk(e.target.value)}
                                        style={{ height: '45px' }}
                                    />
                                </div>
                                <div className="col-lg-6 mb-3">
                                    <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Tapped</label>
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        value={tapped} 
                                        onChange={(e) => setTapped(e.target.value)}
                                        style={{ height: '45px' }}
                                    />
                                </div>
                                <div className="col-lg-6 mb-3">
                                    <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Mesh Size</label>
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        value={meshSize} 
                                        onChange={(e) => setMeshSize(e.target.value)}
                                        style={{ height: '45px' }}
                                    />
                                </div>
                                <div className="col-lg-6 mb-3">
                                    <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Arsenic</label>
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        value={arsenic} 
                                        onChange={(e) => setArsenic(e.target.value)}
                                        style={{ height: '45px' }}
                                    />
                                </div>
                                <div className="col-lg-6 mb-3">
                                    <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Cadmium</label>
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        value={cadmium} 
                                        onChange={(e) => setCadmium(e.target.value)}
                                        style={{ height: '45px' }}
                                    />
                                </div>
                                <div className="col-lg-6 mb-3">
                                    <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Lead</label>
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        value={leadx} 
                                        onChange={(e) => setLeadx(e.target.value)}
                                        style={{ height: '45px' }}
                                    />
                                </div>
                                <div className="col-lg-6 mb-3">
                                    <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Mercury</label>
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        value={mercury} 
                                        onChange={(e) => setMercury(e.target.value)}
                                        style={{ height: '45px' }}
                                    />
                                </div>
                                <div className="col-lg-6 mb-3">
                                    <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>TAMC</label>
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        value={tamc} 
                                        onChange={(e) => setTAMC(e.target.value)}
                                        style={{ height: '45px' }}
                                    />
                                </div>
                                <div className="col-lg-6 mb-3">
                                    <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>TYMC</label>
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        value={tymc} 
                                        onChange={(e) => setTYMC(e.target.value)}
                                        style={{ height: '45px' }}
                                    />
                                </div>
                                <div className="col-lg-6 mb-3">
                                    <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Coliforms</label>
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        value={coliforms} 
                                        onChange={(e) => setColiforms(e.target.value)}
                                        style={{ height: '45px' }}
                                    />
                                </div>
                                <div className="col-lg-6 mb-3">
                                    <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>E. coli</label>
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        value={eColi} 
                                        onChange={(e) => setEColi(e.target.value)}
                                        style={{ height: '45px' }}
                                    />
                                </div>
                                <div className="col-lg-6 mb-3">
                                    <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Salmonella spp.</label>
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        value={salmonellaSpp} 
                                        onChange={(e) => setSalmonellaSpp(e.target.value)}
                                        style={{ height: '45px' }}
                                    />
                                </div>
                                <div className="col-lg-6 mb-3">
                                    <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Staph aureus</label>
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        value={staphAureus} 
                                        onChange={(e) => setStaphAureus(e.target.value)}
                                        style={{ height: '45px' }}
                                    />
                                </div>
                                <div className="col-lg-6 mb-3">
                                    <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Absent</label>
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        value={absent} 
                                        onChange={(e) => setAbsent(e.target.value)}
                                        style={{ height: '45px' }}
                                    />
                                </div>
                                <div className="col-lg-6 mb-3">
                                    <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Milk</label>
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        value={milk} 
                                        onChange={(e) => setMilk(e.target.value)}
                                        style={{ height: '45px' }}
                                    />
                                </div>
                                <div className="col-lg-6 mb-3">
                                    <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Egg</label>
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        value={egg} 
                                        onChange={(e) => setEgg(e.target.value)}
                                        style={{ height: '45px' }}
                                    />
                                </div>
                                <div className="col-lg-6 mb-3">
                                    <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Soy</label>
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        value={soy} 
                                        onChange={(e) => setSoy(e.target.value)}
                                        style={{ height: '45px' }}
                                    />
                                </div>
                                <div className="col-lg-6 mb-3">
                                    <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Fish</label>
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        value={fish} 
                                        onChange={(e) => setFish(e.target.value)}
                                        style={{ height: '45px' }}
                                    />
                                </div>
                                <div className="col-lg-6 mb-3">
                                    <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Shellfish</label>
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        value={shellfish} 
                                        onChange={(e) => setShellfish(e.target.value)}
                                        style={{ height: '45px' }}
                                    />
                                </div>
                                <div className="col-lg-6 mb-3">
                                    <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Tree Nuts</label>
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        value={treeNuts} 
                                        onChange={(e) => setTreeNuts(e.target.value)}
                                        style={{ height: '45px' }}
                                    />
                                </div>
                                <div className="col-lg-6 mb-3">
                                    <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Peanuts</label>
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        value={peanuts} 
                                        onChange={(e) => setPeanuts(e.target.value)}
                                        style={{ height: '45px' }}
                                    />
                                </div>
                                <div className="col-lg-6 mb-3">
                                    <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Wheat</label>
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        value={wheat} 
                                        onChange={(e) => setWheat(e.target.value)}
                                        style={{ height: '45px' }}
                                    />
                                </div>
                                <div className="col-lg-6 mb-3">
                                    <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Gluten*</label>
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        value={gluten} 
                                        onChange={(e) => setGluten(e.target.value)}
                                        style={{ height: '45px' }}
                                    />
                                </div>
                                <div className="col-lg-6 mb-3">
                                    <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Overage</label>
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        value={overage} 
                                        onChange={(e) => setOverage(e.target.value)}
                                        style={{ height: '45px' }}
                                    />
                                </div>
                                <div className="col-lg-6 mb-3">
                                    <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Cost</label>
                                    <input 
                                        type="number" 
                                        step="0.01" 
                                        className="form-control" 
                                        value={cost} 
                                        onChange={(e) => setCost(e.target.value)}
                                        style={{ height: '45px' }}
                                    />
                                </div>
                                <div className="col-lg-6 mb-3">
                                    <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Cost Unit</label>
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        value={costUnit} 
                                        onChange={(e) => setCostUnit(e.target.value)}
                                        style={{ height: '45px' }}
                                    />
                                </div>
                                <div className="col-lg-6 mb-3">
                                    <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Cost/g</label>
                                    <input 
                                        type="number" 
                                        step="0.01" 
                                        className="form-control" 
                                        value={costG} 
                                        onChange={(e) => setCostG(e.target.value)}
                                        style={{ height: '45px' }}
                                    />
                                </div>
                                <div className="col-lg-6 mb-3">
                                    <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>MOQ (kg)</label>
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        value={moqKg} 
                                        onChange={(e) => setMOQKg(e.target.value)}
                                        style={{ height: '45px' }}
                                    />
                                </div>
                                <div className="col-lg-6 mb-3">
                                    <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Amazon Testing</label>
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        value={amazonTesting} 
                                        onChange={(e) => setAmazonTesting(e.target.value)}
                                        style={{ height: '45px' }}
                                    />
                                </div>
                                <div className="col-lg-6 mb-3">
                                    <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Laboratory</label>
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        value={laboratory} 
                                        onChange={(e) => setLaboratory(e.target.value)}
                                        style={{ height: '45px' }}
                                    />
                                </div>
                                <div className="col-lg-6 mb-3">
                                    <label style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Solubility (g/mL)</label>
                                    <input 
                                        type="number" 
                                        step="0.01" 
                                        className="form-control" 
                                        value={solubilityGML} 
                                        onChange={(e) => setSolubilityGML(e.target.value)}
                                        style={{ height: '45px' }}
                                    />
                                </div>
                            </div>
                        </div>
                        </form>

                        {/* Action Buttons */}
                        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '15px', paddingBottom: '30px' }}>
                            <button 
                                className="btn btn-outline-secondary"
                                onClick={() => toast.info("Draft saved successfully!")}
                                style={{ padding: '12px 24px', fontWeight: '500' }}
                            >
                                Save Draft
                            </button>
                            <button 
                                className="btn btn-primary"
                                onClick={onSaveClick}
                                style={{ padding: '12px 24px', fontWeight: '500', backgroundColor: '#17a2b8', borderColor: '#17a2b8' }}
                            >
                                Create Part
                            </button>
                        </div>

                    </div>
                </div>
                <ToastContainer />
            </Layout>
        );
}

export default AddRaws;
